import { useState } from "react";

export const usePriceFormat = (initialApiFormat?: number) => {
  const [apiFormat, setApiFormat] = useState<number | null>(
    initialApiFormat === undefined ? null : initialApiFormat,
  );
  const [inputFormat, setInputFormat] = useState(
    initialApiFormat === undefined ? "" : (initialApiFormat / 100).toString(),
  );
  const [prevInitialApiFormat, setPrevInitialApiFormat] =
    useState(initialApiFormat);

  // Sync local formats when the controlled initial value changes.
  // https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
  if (initialApiFormat !== prevInitialApiFormat) {
    setPrevInitialApiFormat(initialApiFormat);
    if (initialApiFormat === undefined) {
      setInputFormat("");
      setApiFormat(null);
    } else {
      setInputFormat((initialApiFormat / 100).toString());
      setApiFormat(initialApiFormat);
    }
  }

  const setInputFormatState = (inputPrice: string) => {
    setInputFormat(inputPrice);
    setApiFormat(formatPriceInputToApi(inputPrice));
  };

  const setApiFormatState = (apiPrice: number | null) => {
    setApiFormat(apiPrice);
    setInputFormat(
      apiPrice === undefined ? "" : formatPriceApiToInput(apiPrice).toString(),
    );
  };

  return {
    apiFormat,
    inputFormat,
    setInputFormat: setInputFormatState,
    setApiFormat: setApiFormatState,
  };
};

export const formatPriceApiToInput = (apiPrice: number | null) => {
  if (apiPrice === null) return "";
  return parseFloat((apiPrice / 100).toFixed(2)).toString();
};

export const formatPriceInputToApi = (inputPrice: string | number) => {
  const float = parseFloat(inputPrice.toString());
  if (Number.isNaN(float)) return null;
  // This seems to be needed to avoid floating point recurrence issues
  return parseInt((parseFloat(inputPrice.toString()) * 100).toFixed(2));
};
